import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Agencies } from 'app/models/agencies';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { PrimeNGConfig } from 'primeng/api';
import { SearchService } from 'app/services/search/search.service';
@Component({
  selector: 'app-agences-bizerte',
  templateUrl: './agences-bizerte.component.html',
  styleUrls: ['./agences-bizerte.component.scss']
})
export class AgencesBizerteComponent implements OnInit {
  @ViewChild('agencyForm', { static: false })
  closeResult = '';
  search_name1:any;
  public search: string  = ''
  agencyForm: NgForm;
  p: Number = 1;
  lengthSociete=10
  totalSociete : any

  agenciedData: Agencies;
  dataSource = new MatTableDataSource();
  displayedColumns: string[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isEditMode = false;
  public agencies:any
  public idAgency: any
  public Agency: any

  pageIndex:number = 0;
  pageSize:number = 50;
  lowValue:number = 0;
  highValue:number = 50; 
  AgenciesTunis:any

  constructor(private agenciesService: AgenciesService,
    private primengConfig: PrimeNGConfig ,
    private searchService: SearchService ) { }

  ngOnInit() {
 
    this.getagencesBizerte();

  }
  getagencesBizerte() {
    this.agenciesService.getListAgenceBizete().subscribe((data: any) => {
      this.AgenciesTunis = data;
      console.log("liste des promteurs à bizerte", this.AgenciesTunis);
      // Filtrer les promoteurs de Tunis
      this.agencies = this.AgenciesTunis.filter((agencie: any) => {
        return agencie.region === 'Bizerte'; 
        this.performSearch(); // Filtre uniquement les promoteurs ayant la région "Bizerte"
      });
        
    });
  }
  




  cancelEdit() {
    this.isEditMode = false;
    this.agencyForm.resetForm();
  }

  deleteAgencies(agencie: any) {
    this.agenciesService.deleteItem(agencie.id).subscribe((response: any) => {

      console.log(this.dataSource.data);

    });
  
    
  }

 public changePage(){
  this.lengthSociete=this.lengthSociete+10;
}


  
performSearch() {
  this.AgenciesTunis = this.searchService.search(this.AgenciesTunis, this.search);
}
}